import PropTypes from 'prop-types'
import React from 'react'
import { useForm, FormProvider } from 'react-hook-form'
import { useDispatch, useSelector } from 'react-redux'
import { Alert } from 'reactstrap'

import { PageLoader } from '../../generic'
import { reset as resetPassword } from '../store/actions'
import { getSubmitting } from '../store/selectors'

import Input from './generic/Input'
import SubmitButton from './generic/SubmiButton'
import useErrors from './generic/useErrors'

const ResetPasswordForm = (
  {
    formData: {
      email: initialEmail = ''
    } = {}
  }
) => {
  const dispatch = useDispatch()
  const methods = useForm({
    defaultValues: {
      email: initialEmail
    }
  })
  const { handleSubmit, setError } = methods
  const isSubmitting = useSelector(getSubmitting)
  const { formSubmitMessages, resetErrors } = useErrors(setError)

  const onSubmit = data => {
    resetErrors()
    dispatch(resetPassword(data))
  }

  return (
    <FormProvider {...methods}>
      <form
        className='form form-reset qa-form-reset'
        onSubmit={handleSubmit(onSubmit)}
      >
        {formSubmitMessages.length > 0 &&
          <div>
            <Alert color='danger'>{formSubmitMessages.toString()}</Alert>
          </div>}
        <p>Bitte geben Sie hier Ihre E-Mail-Adresse ein und wir senden Ihnen Informationen zu, mit denen
          Sie Ihr Passwort zurücksetzen können.
        </p>
        <div className='form-group'>
          <Input
            type='email'
            className='form-control qa-email'
            placeholder='E-Mail'
            name='email'
            required
          />
        </div>
        <div className='d-flex flex-column flex-lg-row justify-content-around w-100 mb-lg-2'>
          {isSubmitting
            ? <PageLoader />
            : <SubmitButton classname='btn btn-primary' text='Passwort zurücksetzen' />}
        </div>
      </form>
    </FormProvider>
  )
}

ResetPasswordForm.propTypes = {
  formData: PropTypes.shape({
    email: PropTypes.string
  })
}

export default ResetPasswordForm
